import {call, put, takeLatest} from 'redux-saga/effects';
import {
  getSpecializationFailure,
  getSpecializationRequest,
  getSpecializationSuccess,
  getLandingSpecialistListFailure,
  getLandingSpecialistListRequest,
  getLandingSpecialistListSuccess,
  getCountryListFailure,
  getCountryListRequest,
  getCountryListSuccess,
  getAdminRolesFailure,
  getAdminRolesRequest,
  getAdminRolesSuccess,

  // get filter options specialist
  getSpecialistFilterOptionsFailure,
  getSpecialistFilterOptionsRequest,
  getSpecialistFilterOptionsSuccess,
} from '../slices/appSettingSlice';

import {
  fetchSpecialization,
  fetchSpecialistList,
  fetchCountryList,
  getRoleFilterOptions,
  getSpecialistFilterOptions
} from '@/services/api';
import {SUCCESS_KEY} from '@/constants/keys';

function* fetchSpecializationSaga(): Generator {
  try {
    const response: any = yield call(fetchSpecialization);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getSpecializationSuccess(response.data));
    } else {
      yield put(getSpecializationFailure(response.data));
    }
  } catch (error: any) {
    yield put(getSpecializationFailure(error.response));
  }
}

function* fetchLandingSpecialistListSaga(): Generator {
  try {
    const response: any = yield call(fetchSpecialistList);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getLandingSpecialistListSuccess(response.data));
    } else {
      yield put(getLandingSpecialistListFailure(response.data));
    }
  } catch (error: any) {
    yield put(getLandingSpecialistListFailure(error.response));
  }
}

function* fetchCountryListSaga(): Generator {
  try {
    const response: any = yield call(fetchCountryList);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getCountryListSuccess(response.data));
    } else {
      yield put(getCountryListFailure(response.data));
    }
  } catch (error: any) {
    yield put(getCountryListFailure(error.response));
  }
}

function* fetchAdminRolesSaga(): Generator {
  try {
    const response: any = yield call(getRoleFilterOptions);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getAdminRolesSuccess(response.data));
    } else {
      yield put(getAdminRolesFailure(response.data));
    }
  } catch (error: any) {
    yield put(getAdminRolesFailure(error.response));
  }
}

function* fetchSpecialistFilterOptionsSaga(): Generator {
  try {
    const response: any = yield call(getSpecialistFilterOptions);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getSpecialistFilterOptionsSuccess(response.data));
    } else {
      yield put(getSpecialistFilterOptionsFailure(response.data));
    }
  } catch (error: any) {
    yield put(getSpecialistFilterOptionsFailure(error.response));
  }
}

export default function* appSettingsSaga(): Generator {
    yield takeLatest(getSpecializationRequest.type, fetchSpecializationSaga);
    yield takeLatest(getLandingSpecialistListRequest.type, fetchLandingSpecialistListSaga);
    yield takeLatest(getCountryListRequest.type, fetchCountryListSaga);
    yield takeLatest(getAdminRolesRequest.type, fetchAdminRolesSaga);
    yield takeLatest(getSpecialistFilterOptionsRequest.type, fetchSpecialistFilterOptionsSaga);
}
